module.exports = __webpack_public_path__ + "1d5a773585eaaf94e1708f8b1323d9c7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SI.svg
// module id = toJH
// module chunks = 0